export default "__VITE_ASSET__b2c5a0fd__"